import Country from '@/domain/country/Country';

export default () => (
  country,
) => Country.nifMandatoryById(country);
